import React from 'react';
import { API } from 'aws-amplify';
import { toast } from 'react-toastify';
import { t } from 'i18next';

/**A React Hook for controlling the state of the ChangeUsername UI.
 * @param {string} userId The UserID parameter from the URL.
 * @param {string} callback A callback function to handle any cleanup or state changes once the Password changes.
 */
const useChangeUsername = (userId, callback) => {
    const [UserID] = React.useState(userId);
    const [isInitialized, setIsInitialized] = React.useState(false);
    const [isDoingAjax, setIsDoingAjax] = React.useState(true);

    const [currentUserName, setCurrentUserName] = React.useState('');
    const [newUserName, setNewUserName] = React.useState('');

    const updateNewUsername = (_newUserName) => {
        setNewUserName(_newUserName);
    };

    async function fetchUserData() {
        setIsDoingAjax(true);

        let response = await API.get('ShipyardAPI', `/usersettings/${userId}`, {
            queryStringParameters: {
                userNameOnly: true,
            },
        });

        setCurrentUserName(response?.userName ? response.userName : '');

        setIsDoingAjax(false);
        setIsInitialized(true);
    }

    async function changeUsername() {
        setIsDoingAjax(true);

        try {
            await API.patch('ShipyardAPI', `/usersettings/${UserID}`, {
                body: {
                    newUsername: newUserName,
                },
                queryStringParameters: {
                    changeUsername: true,
                },
            });

            toast.success('Username changed successfully!');

            callback?.(newUserName);
        } catch (e) {
            if (e?.response?.data?.message) {
                toast.error(t(e.response.data.message));
            } else if (e?.message) {
                toast.error(t(e.message));
            } else {
                toast.error(t('General.AjaxError'));
            }
            setIsDoingAjax(false);
        }
    }

    return {
        isInitialized,
        isDoingAjax,
        currentUserName,
        newUserName,
        fetchUserData,
        updateNewUsername,
        changeUsername,
    };
};

export default useChangeUsername;
